module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/PrizeSlider/img/new/jarvis_text-3e705889d07373709b562885316a6507.png";